import { get } from "@insite/client-framework/Services/ApiService";
import { LoyaltyCollectionModel, LoyaltyUserModel } from "./LoyaltyRewardsModel";

const loyaltyRewardsUrl = "api/v2/rewards";
const loyaltyUserUrl="api/v2/rewardsUser";

let currentDateTime = new Date();
const offsetMinutes = currentDateTime.getTimezoneOffset();
const localTime = new Date(currentDateTime.getTime() - offsetMinutes * 60 * 1000);
let date = localTime.toJSON().replace("T", " ");
date = date == null || date == "" ? "" : date;

export const getLoyaltyRewards = (parameter?: any) => {
    return get<LoyaltyCollectionModel>(`${loyaltyRewardsUrl}?userDateTime=${date}`, parameter);
};

export const getLoyaltyUser = (parameter?: any) => {
    return get<LoyaltyUserModel>(`${loyaltyUserUrl}`, parameter);
};